const example = {
  1: "https://growing-iq.web.app/levels/level1.html",
  2: "https://growing-iq.web.app/levels/level2.html",
  3: "https://growing-iq.web.app/levels/level3.html",
  4: "https://growing-iq.web.app/levels/level4.html",
  5: "https://growing-iq.web.app/levels/level5.html",
};

const brochure = {
  1: "https://1drv.ms/b/s!AvLS225hOMDFilLy7ZU2A0u8LWyL",
  2: "https://1drv.ms/b/s!AvLS225hOMDFilflPNdOpDW5_zhN",
  3: "https://1drv.ms/b/s!AvLS225hOMDFilrNnzlxUhSb4jWL",
  4: "https://1drv.ms/b/s!AvLS225hOMDFil3ANKBntTbRBc_Y",
  5: "https://1drv.ms/b/s!AvLS225hOMDFimAwAVkyCaB-Fi8D",
};

const location_info = {
  "Honolulu, HI": {
    phone: "8084473362",
    email: "Hawaii@GrowingIQ.com",
    address: "4211 Waialae Ave #100a, Honolulu, HI, 96816",
    country: "US",
  },
  "Sunnyvale, CA": {
    phone: "4084987194",
    email: "SiliconValley@GrowingIQ.com",
    address: "750 Sunnyvale Saratoga Rd, Sunnyvale, CA, 94087",
    country: "US",
  },
  "Hong Kong, HK": {
    phone: "+852 2323 9899",
    email: "teachers@growingiq.com.hk",
    address:
      "4/F, China Hong Kong Tower, 8-12 Hennessy Rd, Admiralty, Hong Kong",
    country: "HK",
  },
  "Redwood City, CA": {
    phone: "6505022447",
    email: "RWC@GrowingIQ.com",
    address: "2539 El Camino Real, Redwood City, CA 94061",
    country: "US",
  },
};

const country_links = {
  US: {
    about: "https://www.growingiq.com",
    curriculum: "https://www.growingiq.com/curriculum",
    contact: "https://www.growingiq.com/contact-us",
    facebook: "https://www.facebook.com/GrowingIQ.USA/",
    linkedin: "https://www.linkedin.com/company/growingiq/",
    instagram: "https://www.instagram.com/growingiq.usa/",
  },
  HK: {
    about: "https://www.growingiq.com.hk",
    curriculum: "https://www.growingiq.com.hk/curriculum",
    contact: "https://www.growingiq.com.hk/book-a-free-assessment",
    facebook: "https://www.facebook.com/GrowingIQ.hk/",
    linkedin: "https://www.linkedin.com/company/growingiq/",
    instagram: "https://www.instagram.com/growingiq.hk/",
  },
};

const template = (mailData) => {
  return `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<!--[if (gte mso 9)|(IE)]>
  <xml>
    <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
  </o:OfficeDocumentSettings>
</xml>
<![endif]-->
<meta http-equiv="Content-Type" content="text/html;charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1"> <!-- So that mobile will display zoomed in -->
<meta http-equiv="X-UA-Compatible" content="IE=edge"> <!-- enable media queries for windows phone 8 -->
<meta name="format-detection" content="telephone=no"> <!-- disable auto telephone linking in iOS -->
<meta name="format-detection" content="date=no"> <!-- disable auto date linking in iOS -->
<meta name="format-detection" content="address=no"> <!-- disable auto address linking in iOS -->
<meta name="format-detection" content="email=no"> <!-- disable auto email linking in iOS -->
<title></title>
<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&amp;display=swap" rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&amp;display=swap" rel="stylesheet">
<style type="text/css">
/*Basics*/
body {margin:0px!important;padding:0px!important;display:block!important;min-width:100%!important;width:100%!important;-webkit-text-size-adjust:none;}
table {border-spacing:0;mso-table-lspace:0pt;mso-table-rspace:0pt;}
table td {border-collapse:collapse;mso-line-height-rule:exactly;}
td img {-ms-interpolation-mode:bicubic;width:auto;max-width:auto;height:auto;margin:auto;display:block!important;border:0px;}
td p {margin:0;padding:0;}
td div {margin:0;padding:0;}
td a {text-decoration:none;color:inherit;}
/*Outlook*/
.ExternalClass {width:100%;}
.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {line-height:inherit;}
.ReadMsgBody {width:100%;background-color:#ffffff;}
/* iOS BLUE LINKS */
a[x-apple-data-detectors] {color:inherit!important;text-decoration:none!important;font-size:inherit!important;font-family:inherit!important;font-weight:inherit!important;line-height:inherit!important;} 
/*Gmail blue links*/
u + #body a {color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit;}
/*Buttons fix*/
.undoreset a, .undoreset a:hover {text-decoration:none!important;}
.yshortcuts a {border-bottom:none!important;}
.ios-footer a {color:#aaaaaa!important;text-decoration:none;}
/*Responsive*/
@media screen and (max-width:799px) {
  table.row {width:100%!important;max-width:100%!important;}
  td.row {width:100%!important;max-width:100%!important;}
  .img-responsive img {width:100%!important;max-width:100%!important;height:auto!important;margin:auto;}
  .center-float {float:none!important;}
  .center-text{text-align:center!important;}
  .container-padding {width:100%!important;padding-left:15px!important;padding-right:15px!important;}
  .container-padding10 {width:100%!important;padding-left:10px!important;padding-right:10px!important;}
  .hide-mobile {display:none!important;}
  .menu-container {text-align:center!important;}
  .autoheight {height:auto!important;}
  .m-padding-10 {margin:10px 0!important;}
  .m-padding-15 {margin:15px 0!important;}
  .m-padding-20 {margin:20px 0!important;}
  .m-padding-30 {margin:30px 0!important;}
  .m-padding-40 {margin:40px 0!important;}
  .m-padding-50 {margin:50px 0!important;}
  .m-padding-60 {margin:60px 0!important;}
  .m-padding-top10 {margin:30px 0 0 0!important;}
  .m-padding-top15 {margin:15px 0 0 0!important;}
  .m-padding-top20 {margin:20px 0 0 0!important;}
  .m-padding-top30 {margin:30px 0 0 0!important;}
  .m-padding-top40 {margin:40px 0 0 0!important;}
  .m-padding-top50 {margin:50px 0 0 0!important;}
  .m-padding-top60 {margin:60px 0 0 0!important;}
  .m-height10 {font-size:10px!important;line-height:10px!important;height:10px!important;}
  .m-height15 {font-size:15px!important;line-height:15px!important;height:15px!important;}
  .m-height20 {font-size:20px!important;line-height:20px!important;height:20px!important;}
  .m-height25 {font-size:25px!important;line-height:25px!important;height:25px!important;}
  .m-height30 {font-size:30px!important;line-height:30px!important;height:30px!important;}
  .rwd-on-mobile {display:inline-block!important;padding:5px;}
  .center-on-mobile {text-align:center!important;}
}
</style>

</head>
<body style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;width:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;" bgcolor="#F4F4F4">
<span class="preheader-text" style="color:transparent;height:0;max-height:0;max-width:0;opacity:0;overflow:hidden;visibility:hidden;width:0;display:none;mso-hide:all;"></span>
<!-- Preheader white space hack -->
<div style="display:none;max-height:0px;overflow:hidden;">
‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;‌&nbsp;
</div>

<table border="0" align="center" cellpadding="0" cellspacing="0" width="100%" style="width:100%;max-width:100%;">
  <tbody><tr><!-- Outer Table -->
    <td align="center" bgcolor="#F4F4F4">
    <table border="0" align="center" cellpadding="0" cellspacing="0" class="row" width="800" style="width:800px;max-width:800px;">
  <!-- milia-header-1 -->
  <tbody><tr>
    <td align="center" bgcolor="#000000">
<!--[if (gte mso 9)|(IE)]><v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:800px;">
<v:fill type="frame" src="<iframe src='https://onedrive.live.com/embed?cid=C5C038616EDBD2F2&amp;resid=C5C038616EDBD2F2%212485&amp;authkey=AD1Drmu0mniUdHA'width='98'height='120'frameborder='0'scrolling='no'></iframe>" color="#000000" opacity="100%"></v:fill>
<v:textbox style="mso-fit-shape-to-text:true;" inset="0,0,0,0"><![endif]-->
<div>
<!-- milia-header-1-bg-image -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="width:100%;max-width:100%;">
  <tbody><tr>
    <td align="center" background="https://snz04pap001files.storage.live.com/y4m0BXLzLQeyQKkKamx_U00uofZbXCw6XGvEFl_C-CZuGT1KsgnQFrPaxcwDzCTvpUllc3NzQOOMbDT5mxXbN3nl44X7s0_axnK7ChKUD0fyyxFP6gtirEZIwwq7NWJO1pQDHrVbKsR6rnnpKSIgaMxkCaGF_v75jKxjnFJGAIB1FaC51LStfnfPqSmNM4_N4wp?width=5694&amp;height=3801&amp;cropmode=none" style="background-size:cover;background-position:center top;">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="40" style="font-size:40px;line-height:40px;">&nbsp;</td>
  </tr>
  <tr style="">
    <td align="center">
<!-- row -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="100%" style="width:100%;max-width:100%;">
  <tbody><tr>
    <td align="center">
    <!--[if (gte mso 9)|(IE)]><table border="0" cellpadding="0" cellspacing="0"><tr><td><![endif]-->
    <!-- column -->
    <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="200" style="width:200px;max-width:200px;">
      <tbody><tr style="">
      <a href=${country_links[location_info[mailData.location].country].about}>
        <td align="left" class="center-text">
          <img style="width:110px;border:0px;display:inline!important;" src="https://snz04pap001files.storage.live.com/y4mhvOHyMxy_g7ZLq_K6sSMA0lIEzcE1aTBaUbv6bG-WQiH4SaHXjb66i9JajJF6XmtTgEtMcyXrMWdx8B3X15ltDnPGkIBAkf3JvoGCZOuokjR-pgk2PqGHpHbFwpfm7VYBupDZ4tz7vuMXvNmySYv4CLHvcC_BW8RpQovUk2WUBe5JKo0ONjRLR-nnD_sJMMI?width=2055&amp;height=1553&amp;cropmode=none" width="110" border="0" alt="logo">
        </td>
        </a>
      </tr>
    </tbody></table>
    <!-- column -->
    <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
    <!-- gap -->
    <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="20" style="width:20px;max-width:20px;">
      <tbody><tr>
        <td height="20" style="font-size:20px;line-height:20px;">&nbsp;</td>
      </tr>
    </tbody></table>
    <!-- gap -->
    <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
    <!-- column -->
    <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="380" style="width:380px;max-width:380px;">
      <tbody><tr>
        <td class="center-text" align="right" height="30" style="height:30px;">
        <!-- Navigation Group -->
          <table border="0" cellpadding="0" cellspacing="0" align="right" class="center-float" style="">
            <tbody><tr class="center-on-mobile">
              <td class="rwd-on-mobile" align="center">
          <!-- Button -->
          <table border="0" cellpadding="0" cellspacing="0" align="center">
            <tbody><tr>
              <td align="center" width="10"></td>
              <td align="center">
                
                  <a href=${
                    country_links[location_info[mailData.location].country]
                      .about
                  } target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;font-weight:700;font-style:normal;color:rgb(255, 255, 255);text-decoration:none;letter-spacing:0px;"><span>About Us</span></a>
                
              </td>
              <td align="center" width="10"></td>
            </tr>
          </tbody></table>
          <!-- Button -->
          </td>
          <td class="rwd-on-mobile" align="center">
          <!-- Button -->
          <table border="0" cellpadding="0" cellspacing="0" align="center">
            <tbody><tr>
              <td align="center" width="10"></td>
              <td align="center">
                
                  <a href=${
                    country_links[location_info[mailData.location].country]
                      .curriculum
                  }  target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;font-weight:700;font-style:normal;color:rgb(255, 255, 255);text-decoration:none;letter-spacing:0px;"><span>Curriculum</span></a>
                
              </td>
              <td align="center" width="10"></td>
            </tr>
          </tbody></table>
          <!-- Button -->
          </td>
          
            <td class="rwd-on-mobile" align="center">
          <!-- Button -->
          <table border="0" cellpadding="0" cellspacing="0" align="center">
            <tbody><tr>
              <td align="center" width="10"></td>
              <td align="center">
                
                  <a href=${
                    country_links[location_info[mailData.location].country]
                      .contact
                  }  target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;font-weight:700;font-style:normal;color:rgb(255, 255, 255);text-decoration:none;letter-spacing:0px;"><span>Contact</span></a>
                
              </td>
              <td align="center" width="10"></td>
            </tr>
          </tbody></table>
          <!-- Button -->
              </td>
            </tr>
          </tbody></table>
          <!-- Navigation Group -->
        </td>
      </tr>
    </tbody></table>
    <!-- column -->
    <!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->
    </td>
  </tr>
</tbody></table>
<!-- row -->
    </td>
  </tr>
  <tr style="">
    <td height="80" style="font-size:80px;line-height:80px;">&nbsp;</td>
  </tr>
  <tr style="">
    <td class="center-text container-padding" align="center" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:50px;line-height:30px;font-weight:300;font-style:normal;color:rgb(255, 255, 255);text-decoration:none;letter-spacing:0px;">
        
          <div style="margin: 0px; padding: 0px;">
            <p style="margin: 0px; padding: 0px;"><strong><font color="#73cee5">Discover</font></strong> Math</p></div>
        
    </td>
  </tr>
  <tr style="">
    <td height="39" style="font-size:30px;line-height:39px;">&nbsp;</td>
  </tr>
  
  <tr style="">
    <td align="center">
      <!-- Buttons-Container -->
      <table border="0" cellpadding="0" cellspacing="0" align="center" class="center-float">
        <tbody><tr class="center-on-mobile">
          
            
        </tr>
      </tbody></table>
      <!-- Buttons-Container -->
    </td>
  </tr>
  <tr>
    <td height="30" style="font-size:60px;line-height:30px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
</tbody></table>
<!-- milia-header-1-bg-image -->
</div>
<!--[if (gte mso 9)|(IE)]><p style="margin:0;mso-hide:all"><o:p xmlns:o="urn:schemas-microsoft-com:office:office">&nbsp;</o:p></p></v:textbox></v:rect><![endif]-->
    </td>
  </tr>
  <!-- milia-header-1 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-preface-4 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF" class="container-padding">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="40" style="font-size:40px;line-height:40px;">&nbsp;</td>
  </tr>
  
  
  
  
  <tr>
    <td class="center-text container-padding" align="center" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:13px;line-height:26px;font-weight:400;font-style:normal;color:rgb(0, 0, 0);text-decoration:none;letter-spacing:0px;text-align:justify;">
        
          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
            Thank you for taking the time to come in and learn more about our program.  Hopefully you were able to get a good understanding of who we are and how we operate.</p><p style="margin: 0px; padding: 0px;"><br></p><p style="margin: 0px; padding: 0px;">Our short assessment only provides a glimpse into ${
              mailData.student
            }'s capabilities. We look forward to the opportunity to be a part of ${
    mailData.student
  }'s journey of continued growth and achievement. In the sections below, we will share the assessment data we collected, some initial insights, as well as our recommendations for Growing IQ placement.</p></div>
        
    </td>
  </tr>
  <tr>
    <td height="25" style="font-size:25px;line-height:25px;">&nbsp;</td>
  </tr>
  
  <tr>
    <td height="10" style="font-size:40px;line-height:10px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-preface-4 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-portfolio-1 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="20" style="font-size:30px;line-height:20px;">&nbsp;</td>
  </tr>
  <tr>
    <td class="center-text container-padding" align="center" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:35px;line-height:45px;font-weight:300;font-style:normal;color:#000000;text-decoration:none;letter-spacing:0px;">
        
          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
            ${
              mailData.student + "'s "
            } <strong><font color="#73cee5">Assessment </font></strong></p><p style="margin: 0px; padding: 0px;"><strong style="color:#FF7800;"><br></strong></p></div>
        
    </td>
  </tr>
  
  <tr style="">
    <td align="center" class="img-responsive container-padding">
      <img style="display:block;width:100%;max-width:600px;border:0px;border-radius:0px;" width="600" src="cid:chart" border="0" alt="picture">
    </td>
  </tr>
  <tr>
    <td height="20" style="font-size:20px;line-height:20px;">&nbsp;</td>
  </tr>
  
  <tr>
    <td height="0" style="font-size:30px;line-height:0px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-portfolio-1 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-preface-6 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF" class="container-padding">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="22" style="font-size:40px;line-height:22px;">&nbsp;</td>
  </tr>
  
  
  <tr>
    <td class="center-text container-padding" align="center" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:13px;line-height:26px;font-weight:400;font-style:normal;color:rgb(0, 0, 0);text-decoration:none;letter-spacing:0px;text-align:justify;">
        
          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">${
            mailData.impression
          }</p><p style="margin: 0px; padding: 0px;"><br></p><p style="margin: 0px; padding: 0px;">${
    mailData.strengths
  }</p><p style="margin: 0px; padding: 0px;"><br></p><p style="margin: 0px; padding: 0px;">${
    mailData.growthAreas
  }</p></div>
  <p style="margin: 0px; padding: 0px;"><br></p><p style="margin: 0px; padding: 0px;">${
    mailData.selcr
  }</p></div>
        
    </td>
  </tr>
  <tr>
    <td height="25" style="font-size:25px;line-height:25px;">&nbsp;</td>
  </tr>
  <tr style="">
    <td align="center">
      <!-- Buttons -->
      <table border="0" cellspacing="0" cellpadding="0" role="presentation" align="center" class="center-float">
        <tbody><tr>
          <td align="center" bgcolor="#73cee5" style="border-radius:36px;">
      <!--[if (gte mso 9)|(IE)]>
        <table border="0" cellpadding="0" cellspacing="0" align="center">
          <tr>
            <td align="center" width="20"></td>
            <td align="center" height="46" style="height:46px;">
            <![endif]-->
              
                <a href=${
                  country_links[location_info[mailData.location].country]
                    .curriculum
                }  target="_blank" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;font-weight:700;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;padding:15px 20px 15px 20px;display:inline-block;"><span>Learn More About Our Mathematical Domains</span></a>
              
            <!--[if (gte mso 9)|(IE)]>
            </td>
            <td align="center" width="20"></td>
          </tr>
        </table>
      <![endif]-->
          </td>
        </tr>
      </tbody></table>
      <!-- Buttons -->
    </td>
  </tr>
  <tr>
    <td height="30" style="font-size:40px;line-height:30px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-preface-6 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" width="800" style="width:800px;max-width:800px;">
  <!-- milia-header-7 -->
  <tbody><tr>
    <td align="center" bgcolor="#000000">
<!--[if (gte mso 9)|(IE)]><v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:800px;">
<v:fill type="frame" src="https://snz04pap001files.storage.live.com/y4mjNBLbFWDWb3f29-9rHDqBITA7ssGV6_bjg_lzbRR_AeSbpvqqNGVZTQnnc5tMz4wNWpaLaYmKZdnJlRJP5CsD3v2E0JylXGNeELdR2mkTRxIsI89xlLd7EmJ9tpxLmEc4faFkQSxf5-8q2iAjuEAD7JtRkFoBCEkJROO5Zu8pYjNRhKl9O_G1iLRYI5WAJ1W?width=4902&amp;height=3268&amp;cropmode=none" color="#000000" opacity="100%"></v:fill>
<v:textbox style="mso-fit-shape-to-text:true;" inset="0,0,0,0"><![endif]-->
<div>
<!-- milia-header-7-bg-image -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="width:100%;max-width:100%;">
  <tbody><tr>
    <td align="center" background="https://snz04pap001files.storage.live.com/y4mjNBLbFWDWb3f29-9rHDqBITA7ssGV6_bjg_lzbRR_AeSbpvqqNGVZTQnnc5tMz4wNWpaLaYmKZdnJlRJP5CsD3v2E0JylXGNeELdR2mkTRxIsI89xlLd7EmJ9tpxLmEc4faFkQSxf5-8q2iAjuEAD7JtRkFoBCEkJROO5Zu8pYjNRhKl9O_G1iLRYI5WAJ1W?width=4902&amp;height=3268&amp;cropmode=none" style="background-size:cover;background-position:center top;">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="80" style="font-size:80px;line-height:80px;">&nbsp;</td>
  </tr>
  <tr>
    <td class="center-text container-padding" align="center" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:42px;line-height:52px;font-weight:300;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;">
        
          <div style="margin: 0px; padding: 0px;">
            <p style="margin: 0px; padding: 0px;"><span style="color:rgb(115, 206, 229);"><strong>PLACEMENT:</strong> </span>LEVEL<span style="color:rgb(115, 206, 229);"> </span>${
              mailData.recommendedLevel
            }</p></div>
        
    </td>
  </tr>
  <tr>
    <td height="30" style="font-size:30px;line-height:30px;">&nbsp;</td>
  </tr>
  <tr>
    <td align="center">
      <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="480" style="width:480px;max-width:480px;">
        <tbody><tr>
          <td class="center-text container-padding" align="center" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:13px;line-height:26px;font-weight:300;font-style:normal;color:rgb(255, 255, 255);text-decoration:none;letter-spacing:0px;text-align:justify;">
              
                <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">Based on our assessment, we feel that a <u><strong>Level ${
                  mailData.recommendedLevel
                }</strong></u> is the best fit for ${
    mailData.student
  }. We feel that this level will provide the right combination of challenge and support.</p><p style="margin: 0px; padding: 0px;"><br></p><p style="margin: 0px; padding: 0px;">To learn more about Level ${
    mailData.recommendedLevel
  }, please click the links below.<br></p></div>
              
          </td>
        </tr>
        <tr>
          <td height="30" style="font-size:30px;line-height:30px;">&nbsp;</td>
        </tr>
      </tbody></table>
    </td>
  </tr>
  <tr>
    <td align="center">
      <!-- Buttons-Container -->
      <table border="0" cellpadding="0" cellspacing="0" align="center" class="center-float">
        <tbody><tr class="center-on-mobile">
          <td class="rwd-on-mobile" align="center">
            <!-- Header Button -->
            <table border="0" cellpadding="0" cellspacing="0" align="center">
              <tbody><tr>
                <td colspan="3" height="5" style="font-size:5px;line-height:5px;">&nbsp;</td>
              </tr>
              <tr>
                <td align="center" width="5"></td>
                <td align="center">
                  <!-- Align -->
                  <table border="0" cellspacing="0" cellpadding="0" role="presentation" align="center" class="center-float">
                    <tbody><tr>
                      <td align="center" bgcolor="#73cee5" style="border-radius:36px;">
                  <!--[if (gte mso 9)|(IE)]>
                    <table border="0" cellpadding="0" cellspacing="0" align="center">
                      <tr>
                        <td align="center" width="20"></td>
                        <td align="center" height="44" style="height:44px;">
                        <![endif]-->
                          






                            <a href=${
                              example[mailData.recommendedLevel]
                            } target="_blank" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:14px;line-height:14px;font-weight:700;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;padding:15px 20px 15px 20px;display:inline-block;"><span>Example of Level ${
    mailData.recommendedLevel
  } Class</span></a>
                          







                        <!--[if (gte mso 9)|(IE)]>
                        </td>
                        <td align="center" width="20"></td>
                      </tr>
                    </table>
                  <![endif]-->
                      </td>
                    </tr>
                  </tbody></table>
                  <!-- Align -->
              </td>
              <td align="center" valign="top" width="5"></td>
              </tr>
              <tr>
                <td colspan="3" height="5" style="font-size:5px;line-height:5px;">&nbsp;</td>
              </tr>
            </tbody></table>
            <!-- Header Button -->
            </td>
            <td class="rwd-on-mobile" align="center">
            <!-- Header Button -->
            <table border="0" cellpadding="0" cellspacing="0" align="center">
              <tbody><tr>
                <td colspan="3" height="5" style="font-size:5px;line-height:5px;">&nbsp;</td>
              </tr>
              <tr>
                <td align="center" width="5"></td>
                <td align="center">
                  <!-- Align -->
                  <table border="0" cellspacing="0" cellpadding="0" role="presentation" align="center" class="center-float">
                    <tbody><tr>
                      <td align="center" bgcolor="#FFFFFF" style="border-radius:36px;">
                  <!--[if (gte mso 9)|(IE)]>
                    <table border="0" cellpadding="0" cellspacing="0" align="center">
                      <tr>
                        <td align="center" width="20"></td>
                        <td align="center" height="44" style="height:44px;">
                        <![endif]-->
                          
                            <a href=${
                              brochure[mailData.recommendedLevel]
                            } target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:14px;font-weight:700;font-style:normal;color:rgb(115, 206, 229);text-decoration:none;letter-spacing:0px;padding:15px 20px;display:inline-block;"><span>Level ${
    mailData.recommendedLevel
  } Brochure</span></a>
                          
                        <!--[if (gte mso 9)|(IE)]>
                        </td>
                        <td align="center" width="20"></td>
                      </tr>
                    </table>
                  <![endif]-->
                      </td>
                    </tr>
                  </tbody></table>
                  <!-- Align -->
              </td>
              <td align="center" valign="top" width="5"></td>
              </tr>
              <tr>
                <td colspan="3" height="5" style="font-size:5px;line-height:5px;">&nbsp;</td>
              </tr>
            </tbody></table>
            <!-- Header Button -->
          </td>
        </tr>
      </tbody></table>
      <!-- Buttons-Container -->
    </td>
  </tr>
  <tr>
    <td height="80" style="font-size:80px;line-height:80px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
</tbody></table>
<!-- milia-header-7-bg-image -->
</div>
<!--[if (gte mso 9)|(IE)]><p style="margin:0;mso-hide:all"><o:p xmlns:o="urn:schemas-microsoft-com:office:office">&nbsp;</o:p></p></v:textbox></v:rect><![endif]-->
    </td>
  </tr>
  <!-- milia-header-7 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-preface-5 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF" class="container-padding">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="39" style="font-size:40px;line-height:39px;">&nbsp;</td>
  </tr>
  <tr>
    <td class="center-text container-padding" align="left" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:35px;line-height:45px;font-weight:300;font-style:normal;color:rgb(0, 0, 0);text-decoration:none;letter-spacing:0px;text-align:center;">
        
          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
            NEXT <strong><font color="#73cee5">STEPS</font></strong></p></div>
        
    </td>
  </tr>
  <tr>
    <td height="20" style="font-size:20px;line-height:20px;">&nbsp;</td>
  </tr>
  <tr>
    <td class="center-text container-padding" align="left" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:13px;line-height:26px;font-weight:400;font-style:normal;color:#000000;text-decoration:none;letter-spacing:0px;">
        
          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">

          The next step in the process is to have ${
            mailData.student
          } join a Level ${
    mailData.recommendedLevel
  } class to experience what a class looks like and so we can further ensure that we have found the right fit.
          </p></div>
        
    </td>
  </tr>
  <tr>
    <td height="25" style="font-size:25px;line-height:25px;">&nbsp;</td>
  </tr>
  
  <tr>
    <td height="10" style="font-size:40px;line-height:10px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-preface-5 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-services-4 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="5" style="font-size:40px;line-height:5px;">&nbsp;</td>
  </tr>
  
  
  
  <tr>
    <td align="center">
      <!--[if (gte mso 9)|(IE)]><table border="0" cellpadding="0" cellspacing="0"><tr><td><![endif]-->
      <!-- column -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="280" style="width:280px;max-width:280px;">
        <tbody>
        
        <tr>
          <td class="center-text container-padding" align="center" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:25px;line-height:30px;font-weight:300;font-style:normal;color:#000000;text-decoration:none;letter-spacing:0px;">
              ${mailData.calendarHtml}
          </td>
        </tr>
        <tr>
          <td height="15" style="font-size:15px;line-height:15px;">&nbsp;</td>
        </tr>
        
        
        
      </tbody></table>
      <!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->
    </td>
  </tr>
  <tr>
    <td height="4" style="font-size:40px;line-height:4px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-services-4 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-preheader-2 -->
  <tbody><tr>
    <td align="center" bgcolor="#FFFFFF" class="container-padding">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="width:100%;max-width:100%;">
  <tbody><tr>
    <td height="15" style="font-size:15px;line-height:15px;">&nbsp;</td>
  </tr>
  <tr>
    <td align="center">
<!-- 2-columns -->
<table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td align="center" class="container-padding">
<!--[if (gte mso 9)|(IE)]><table border="0" cellpadding="0" cellspacing="0"><tr><td><![endif]-->
<!-- column -->
<table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="200" style="width:200px;max-width:200px;">
  <tbody><tr>
    <td class="center-text" align="left">
      <a href="#" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:12px;line-height:26px;font-weight:400;color:#7b7b7b;text-decoration:none;letter-spacing:0px;">CONTACT US:</a>
    </td>
  </tr>
</tbody></table>
<!-- column -->
<!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
<!-- gap -->
<table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="20" style="width:20px;max-width:20px;">
  <tbody><tr>
    <td height="10" style="font-size:10px;line-height:10px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- gap -->
<!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
<!-- column -->
<table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="380" style="width:380px;max-width:380px;">
  <tbody><tr style="">
    <td align="center">
      <table border="0" align="right" cellpadding="0" cellspacing="0" role="presentation" class="center-float">
        <tbody><tr>
          <td class="rwd-on-mobile row" align="center" valign="middle" style="">
            <!-- Links -->
            <table border="0" cellspacing="0" cellpadding="0" class="center-float">
              <tbody><tr>
                <td width="10"></td>
                <td align="center">
            <!--[if (gte mso 9)|(IE)]>
              <table border="0" cellpadding="0" cellspacing="0" align="center">
                <tr>
                  <td align="center" height="22" style="height:22px;">
                  <![endif]-->
                    
                      <a href="mailto:${
                        location_info[mailData.location].email
                      }" target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:12px;line-height:12px;font-weight:400;font-style:normal;color:rgb(102, 102, 102);text-decoration:none;letter-spacing:0px;padding:5px 0px;display:inline-block;text-align:center;"><img style="width:16px;border:0px;display:inline-block!important;vertical-align:middle;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/envelope-cl.png" width="16" border="0" alt="Email icon"><img data-icon-space="" style="width:8px;border:0px;display:inline!important;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/gap.gif" width="8" border="0" alt="Space between email icon &amp;link"><span style="display:inline-block;vertical-align:middle;">${
    location_info[mailData.location].email
  }</span></a>
                    
                  <!--[if (gte mso 9)|(IE)]>
                  </td>
                </tr>
              </table>
            <![endif]-->
                </td>
                <td width="10"></td>
              </tr>
            </tbody></table>
            <!-- Links -->
          </td>
          <td class="rwd-on-mobile row" align="center" valign="middle">
            <!-- Links -->
            <table border="0" cellspacing="0" cellpadding="0" class="center-float">
              <tbody><tr>
                <td width="10"></td>
                <td align="center">
            <!--[if (gte mso 9)|(IE)]>
              <table border="0" cellpadding="0" cellspacing="0" align="center">
                <tr>
                  <td align="center" height="22" style="height:22px;">
                  <![endif]-->
                    
                      <a href="tel:${
                        location_info[mailData.location].phone
                      }" target="_blank" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:12px;line-height:12px;font-weight:400;font-style:normal;color:rgb(102, 102, 102);text-decoration:none;letter-spacing:0px;padding:5px 0px;display:inline-block;text-align:center;"><img style="width:16px;border:0px;display:inline-block!important;vertical-align:middle;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/mobile-phone-cl.png" width="16" border="0" alt="Phone number icon"><img data-icon-space="" style="width:8px;border:0px;display:inline!important;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/gap.gif" width="8" border="0" alt="Space between phone icon &amp;link"><span style="display:inline-block;vertical-align:middle;">${
    location_info[mailData.location].phone
  }</span></a>
                    
                  <!--[if (gte mso 9)|(IE)]>
                  </td>
                </tr>
              </table>
            <![endif]-->
                </td>
                <td width="10"></td>
              </tr>
            </tbody></table>
            <!-- Links --> 
          </td>
        </tr>
      </tbody></table>
    </td>
  </tr>
</tbody></table>
<!-- column -->
<!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->
    </td>
  </tr>
</tbody></table>
<!-- 2-columns -->
    </td>
  </tr>
  <tr>
    <td height="15" style="font-size:15px;line-height:15px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-preheader-2 -->
</tbody></table><table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="800" style="width:800px;max-width:800px;">
  <!-- milia-footer-6 -->
  <tbody><tr>
    <td align="center" bgcolor="#222222" class="container-padding">
<!-- Content -->
<table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="600" style="width:600px;max-width:600px;">
  <tbody><tr>
    <td height="30" style="font-size:30px;line-height:30px;">&nbsp;</td>
  </tr>
  <tr>
    <td align="center">
    <!--[if (gte mso 9)|(IE)]><table border="0" cellpadding="0" cellspacing="0"><tr><td><![endif]-->
      <!-- column -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="180" style="width:180px;max-width:180px;">
        <tbody><tr>
        
          <td align="left" class="center-text">
          <a href=${
            country_links[location_info[mailData.location].country].about
          }>
            <img style="width:110px;border:0px;display:inline!important;" src="https://snz04pap001files.storage.live.com/y4mhvOHyMxy_g7ZLq_K6sSMA0lIEzcE1aTBaUbv6bG-WQiH4SaHXjb66i9JajJF6XmtTgEtMcyXrMWdx8B3X15ltDnPGkIBAkf3JvoGCZOuokjR-pgk2PqGHpHbFwpfm7VYBupDZ4tz7vuMXvNmySYv4CLHvcC_BW8RpQovUk2WUBe5JKo0ONjRLR-nnD_sJMMI?width=2055&amp;height=1553&amp;cropmode=none" width="110" border="0" alt="logo">
          </a>
            </td>
        </tr>
      </tbody></table>
      <!-- column -->
      <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
      <!-- gap -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="30" style="width:30px;max-width:30px;">
        <tbody><tr>
          <td height="30" style="font-size:30px;line-height:30px;"></td>
        </tr>
      </tbody></table>
      <!-- gap -->
      <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
      <!-- column -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="180" style="width:180px;max-width:180px;">
        <tbody><tr>
          <td class="center-text" align="left" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;font-weight:700;font-style:normal;color:rgb(115, 206, 229);text-decoration:none;letter-spacing:0px;">
              
                <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
                  OUR LOCATION</p></div>
              
          </td>
        </tr>
        <tr>
          <td height="18" style="font-size:18px;line-height:18px;">&nbsp;</td>
        </tr>
        <tr>
          <td class="center-text container-padding" align="left" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:13px;line-height:24px;font-weight:400;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;">
              
                <div style="margin: 0px; padding: 0px;">
                ${location_info[mailData.location].address}
                  <br>
                  <a href=${
                    "tel:" + location_info[mailData.location].phone
                  } style="color: rgb(255, 255, 255); text-decoration: none;">${
    location_info[mailData.location].phone
  }<br></div>
              
          </td>
        </tr>
      </tbody></table>
      <!-- column -->
      <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
      <!-- gap -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="30" style="width:30px;max-width:30px;">
        <tbody><tr>
          <td height="30" style="font-size:30px;line-height:30px;"></td>
        </tr>
      </tbody></table>
      <!-- gap -->
      <!--[if (gte mso 9)|(IE)]></td><td><![endif]-->
      <!-- column -->
      <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="row" width="180" style="width:180px;max-width:180px;">
        <tbody><tr>
          <td class="center-text" align="left" style="font-family:Poppins, Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;font-weight:700;font-style:normal;color:rgb(115, 206, 229);text-decoration:none;letter-spacing:0px;">
              
                <div style="margin: 0px; padding: 0px;">
                  OUR SOCIALS
                </div>
              
          </td>
        </tr>
        <tr>
          <td height="20" style="font-size:20px;line-height:20px;">&nbsp;</td>
        </tr>
        <tr>
          <td align="center">
            <table border="0" align="left" cellpadding="0" cellspacing="0" role="presentation" class="center-float">
              <tbody><tr>
                <td align="left" class="center-text">
                  <!-- Social Links -->
                    
                      <a href=${
                        country_links[location_info[mailData.location].country]
                          .facebook
                      } target="_blank" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:13px;line-height:13px;font-weight:400;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;display:inline-block;"><img style="width:16px;border:0px;display:inline-block!important;vertical-align:middle;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/facebook-wh.png" width="16" border="0" alt="icon"><img data-icon-space="" style="width:8px;border:0px;display:inline!important;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/gap.gif" width="8" border="0" alt="1st social icon - Space between icon &amp;link"><span>Join us</span></a>
                    
                  <!-- Social Links -->
                </td>
              </tr>
              <tr>
                <td height="15" style="font-size:15px;line-height:15px;">&nbsp;</td>
              </tr>
              
              
              <tr>
                <td align="left" class="center-text">
                  <!-- Social Links -->
                    
                      <a href=${
                        country_links[location_info[mailData.location].country]
                          .linkedin
                      } target="_blank" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:13px;line-height:13px;font-weight:400;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;display:inline-block;"><img style="width:16px;border:0px;display:inline-block!important;vertical-align:middle;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/linkedin-wh.png" width="16" border="0" alt="icon"><img data-icon-space="" style="width:8px;border:0px;display:inline!important;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/gap.gif" width="8" border="0" alt="3rd social icon - Space between icon &amp;link"><span>Stay connected</span></a>
                    
                  <!-- Social Links -->
                </td>
              </tr>
              <tr>
                <td height="15" style="font-size:15px;line-height:15px;">&nbsp;</td>
              </tr>
              <tr>
                <td align="left" class="center-text">
                  <!-- Social Links -->
                    
                      <a href=${
                        country_links[location_info[mailData.location].country]
                          .instagram
                      } target="_blank" style="font-family:'Poppins',Arial,Helvetica,sans-serif;font-size:13px;line-height:13px;font-weight:400;font-style:normal;color:#FFFFFF;text-decoration:none;letter-spacing:0px;display:inline-block;"><img style="width:16px;border:0px;display:inline-block!important;vertical-align:middle;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/instagram-wh.png" width="16" border="0" alt="icon"><img data-icon-space="" style="width:8px;border:0px;display:inline!important;" src="https://modulescomposer.s3.us-east-2.amazonaws.com/milia/gap.gif" width="8" border="0" alt="4th social icon - Space between icon &amp;link"><span>Follow us</span></a>
                    
                  <!-- Social Links -->
                </td>
              </tr>
            </tbody></table>
          </td>
        </tr>
      </tbody></table>
      <!-- column -->
      <!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->
    </td>
  </tr>
  
  
  
  
  <tr>
    <td height="30" style="font-size:30px;line-height:30px;">&nbsp;</td>
  </tr>
</tbody></table>
<!-- Content -->
    </td>
  </tr>
  <!-- milia-footer-6 -->
</tbody></table></td>
  </tr><!-- Outer-Table -->
</tbody></table>
</body>
</html>`;
};

export { template, location_info };
